import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
// import type { GetPromptsReturnType } from "~/types/conversation";
// import {response} from "~/types/conversation";

interface UserDisplayProps {
  question?: string;
  answer?: string;
  // created_at: string;
  showLoading: boolean;
}


export const FinalOutputDisplay: React.FC<UserDisplayProps> = ({
  answer,
  showLoading,
}) => {
  // Function to render HTML content safely
  const renderHTML = (html: string) => {
    // Remove quotes if they exist
    const sanitizedHtml = html.replace(/^"(.*)"$/, '$1');

    // Add spacing and padding to the table content
    const styledHtml = sanitizedHtml
      .replace(/<table>/g, '<table style="width: 100%; border-collapse: collapse; margin-top: 10px;">')
      .replace(/<tr>/g, '<tr style="border-bottom: 1px solid #ddd;">')
      .replace(/<th>/g, '<th style="padding: 8px; text-align: left; background-color: #f2f2f2;">')
      .replace(/<td>/g, '<td style="padding: 8px; text-align: left;">');

    return { __html: styledHtml };
  };

  return (
    <>
      {!showLoading && (
        <div className="flex border-b-2 pb-4">
          <div className="w-1/5"></div>
          <div className="w-5/5">
            <div
              className="relative mb-2 mt-2 whitespace-pre-wrap pr-3 font-nunito font-bold text-gray-90"
              dangerouslySetInnerHTML={renderHTML(answer || "")}
            />
          </div>
        </div>
      )}
    </>
  );
};


export const IdentifierOutputDisplay: React.FC<UserDisplayProps> = ({
  answer,
  showLoading,
}) => {
  // Function to render HTML content safely
  const renderHTML = (html: string) => {
    // Remove square brackets and double quotes from the beginning and end
    const cleanedHtml = html.replace(/^\[["']/, "").replace(/["']\]$/, "");
    // Replace line breaks with <br>
    const replacedHtml1 = cleanedHtml.replace(/\\n/g, "<br>");
    const replacedHtml = replacedHtml1.replace(/\n/g, "<br>");
    return { __html: replacedHtml };
  };

  return (
    <>
      {!showLoading && (
        <div className="flex border-b-2 pb-4">
          <div className="w-1/5"></div>
          <div className="w-5/5">
            {/* Render answer content without the "View Progress" button */}
            <div className="relative whitespace-pre-wrap pr-3 font-nunito font-bold text-gray-90">
              <div dangerouslySetInnerHTML={renderHTML(answer || '')} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};


interface IRenderConversation {
  setUserMessage: (str: string) => void;
  response: any[] | null;
  // prompts: any[] | null;
}

export const RenderConversations: React.FC<IRenderConversation> = ({
  response,
  setUserMessage,
  // prompts
}) => {
  const lastElementRef = useRef<HTMLDivElement | null>(null);
  const [viewProgressMap, setViewProgressMap] = useState<{ [index: number]: boolean }>({});

  // console.log("response in render conversation", response);
  // console.log("usermessage in render conversation", usermessage);
  // console.log("prompts in render conversation", prompts);

  useEffect(() => {
    if (lastElementRef.current) {
      lastElementRef.current.scrollIntoView();
    }
  }, [response]);

  const showLoading = !response;

  const toggleViewProgress = (index: number) => {
    setViewProgressMap((prevMap) => ({
      ...prevMap,
      [index]: !prevMap[index],
    }));
  };

  return (
    <div className="box-border flex h-full flex-col justify-start font-nunito text-sm text-[#2B3175]">
      {response?.map((item, index) => {
        if (item.type === "question") {
          // Render question
          return (
            <div className="mb-2 flex flex-col" key={`question-${index}`}>
              <div className="flex border-r bg-gray-00 pb-4">
                <div className="mt-4 w-4/5 pr-3 font-nunito font-bold text-gray-90">
                  <div style={{ marginLeft: "48px", display: "inline-block" }}>
                    {item.time}
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "48px" }}>
                    {item.question}
                  </div>
                </div>
              </div>
            </div>
          );
        } else if (item.type === "identifier") {
          // Render identifier response with "View Progress" toggle
          return (
            <div className="mb-4 flex flex-col" key={`identifier-${index}`}>
              <div className="flex border-r bg-gray-00 pb-4">
                <div className="mt-4 w-4/5 pr-3 font-nunito font-bold text-gray-90">
                  <div style={{ marginLeft: "200px" }}>
                    <div>{`Identifier: ${item.identifierName}`}</div>
                    <div>
                      <Button
                        className="mb-2 mt-2 p-1 font-nunito text-sm text-blue-500"
                        onClick={() => toggleViewProgress(index)}
                      >
                        {viewProgressMap[index]
                          ? "Hide"
                          : "View"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              {viewProgressMap[index] && (
            <IdentifierOutputDisplay
              answer={item.response || ''} // Pass string instead of array of strings
              showLoading={showLoading}
            />
          )}
            </div>
          );
        } else if (item.type === "doc-comp") {
          // Render doc-comp response
          return (
            <div className="mb-4 flex flex-col" key={`doc-comp-${index}`}>
              <FinalOutputDisplay
                answer={`${item.responses ? JSON.stringify(item.responses) : ""}`}

                showLoading={showLoading}
              />
            </div>
          );
        }
        return null; // Handle other types if needed
      })}

      <div ref={lastElementRef}></div>
    </div>
  );
};

